<template>
  <van-list>
    <van-cell
      v-for="(item, index) in list"
      :key="index"
      center
      :title="item.title || item.eventName"
      :label="item.desc"
      @click="open(item)"
    >
      <template v-if="item.image || item.coverUrl" #right-icon>
        <van-image width="1.6rem" :src="item.image || item.coverUrl" />
      </template>
    </van-cell>
  </van-list>
</template>
<script>
import { PullRefresh, List, Cell, Image } from 'vant'
export default {
  name: 'ArticleList',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Cell.name]: Cell,
    [Image.name]: Image
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  // data() {
  //   return {
  //     param: ''
  //   }
  // },
  // mounted() {
  //   this.param = this.$route.query.param
  // },
  methods: {
    open(item) {
      if (this.type === 'event') {
        const url = '/newEvent'
        this.$router.push({
          path: url,
          query: { eventCode: item.eventCampaignParameter, id: item.id }
        })
      } else {
        if (item && item.content) {
          console.log(item.content)
          this.$router.push({ path: '/m/articleDetail', query: { id: item.id }})
        } else {
          if (item.url && item.url.startsWith('http')) {
            window.open(item.url, '_self')
          }
        }
      }
    }
  }
}
</script>
<style>
.van-cell {
  font-size: 0.28rem !important;
  line-height: 0.48rem !important;
}
.van-cell .van-cell__label {
  font-size: 0.24rem !important;
  line-height: 0.36rem !important;
  margin-top: 0.1rem !important;
}
.van-cell .van-cell__left-icon,
.van-cell .van-cell__right-icon {
  height: 0.48rem;
  font-size: 0.32rem;
  line-height: 0.48rem;
}
</style>
